<template>
  <div >
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="hee hee"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
 
        ref="html2Pdf"
    >
    <section slot="pdf-content">
    <div  class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card >
          <md-card-content>
            <table class="noprint" style="width: 100%; table-layout: fixed; text-transform: capitalize ;">
             <colgroup>
                    <col style="width: 7mm">
                    <col style="width: 18mm">
                    <col style="width: 20mm">
                    <col style="width: 120mm">
                    <col style="width: 15mm">
              </colgroup>
              <tr>
                <td ></td>
                <td></td>
                <td ></td>
                <td><md-button style="float: right; " class="noprint" @click="generateReport()" ><md-icon>print</md-icon></md-button></td>
                <td><md-button style="float: right; " class="noprint" @click="printPage()" ><md-icon>print</md-icon></md-button></td>
                <td >
                  <md-menu md-direction="bottom-start">
                    <md-button class="nonprint; md-info" md-menu-trigger>Option</md-button>
                    <md-menu-content>
                      <md-menu-item @click="editFaktur(faktur.id)">Edit</md-menu-item>
                      <md-menu-item @click="deleteConfirmation(faktur.id)">Delete</md-menu-item>
                    </md-menu-content>
                  </md-menu>
                </td>
              </tr>
              
            </table>
            <table class="print" style="width:100%; table-layout: fixed; border: 1px solid black;" >
            <tr>
              <td style="width:25%; border: 1px solid black;"  rowspan="4"><img src="@/pages/Dashboard/Workshop/Faktur/Component/logo_bengkel_next.png" style="width:100%;  max-width:150px;"></td>
              <td style="padding-left:10mm; font-size: 4mm;  font-weight: 900; text-decoration: underline;">BENGKEL AUTO NEXT</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">BEKASI</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">Jl. Kranggan Raya No. 26 Jatisampurna - Kota Bekasi - Jawa Barat</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">Phone : 081280004426</td>
            </tr>
          </table>
            <table  style="width:100%; border-collapse: collapse; margin-top:5px;">
              <colgroup>
                <col style="width: 140mm">
                <col style="width: 40mm">
              </colgroup>
                <tr>
                  <td style="font-size: 3.5mm;  font-weight: 900; border:1px solid black;">F A K T U R</td>
                  <td style="border:1px solid black; padding-left:3mm" class="bd-left">{{faktur.faktur_no}}</td>
                </tr>
            </table>

            <table style="table-layout: fixed;  margin-top: 2px; width:100%;" >
            <tr>
              <td style="width:65mm">
                <table class="table-inside-td" style="width:100%; table-layout: fixed; border: 1px solid black; margin-top: 2px;" >
                 <tr>&zwnj;</tr>
                  <tr>&zwnj;</tr>
                  <tr>&zwnj;</tr>
                  <tr>&zwnj;</tr>
                </table>
                <table class="table-inside-td" style="width:100%; table-layout: fixed; border: 1px solid black; margin-top: 2px;" >
                 <colgroup>
                    <col style="width: 22mm">
                    <col style="width: 2mm">
                  </colgroup>
                 <tr>
                   <td class="bold-title">Tgl. Faktur</td>
                   <td>:</td>
                   <td>{{faktur.faktur_invoice_datetime}}</td>
                 </tr>
                 <tr>
                     <td class="bold-title">No. pkb</td>
                     <td>:</td>
                     <td>{{faktur.faktur_pkb.pkb_no}}</td>
                  </tr>
                </table>
              </td>
              <td>
                 <table class="table-inside-td" style="table-layout: fixed; width:100%; table-layout: fixed; border: 1px solid black; margin-top: 2px;" >
                  <colgroup>
                    <col style="width: 21mm">
                    <col style="width: 2mm">
                    <col style="width: 32mm">
                    <col style="width: 11mm">
                    <col style="width: 2mm">
                    <col style="width: 25mm">
                  </colgroup>
                  <tr>
                    <td class="bold-title">No. Polisi</td>
                    <td>:</td>
                    <td>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_plate_no}}</td>
                    <td class="bold-title">Nama</td>
                    <td>:</td>
                    <td colspan="4">{{faktur.faktur_pkb.service_estimate.client.client_name}}</td>
                  </tr>
                  <tr>
                    <td class="bold-title">No. Rangka</td>
                    <td>:</td>
                    <td>{{faktur_pkb.service_estimate.vehicle_types.vehicle_chassis_no}}</td>
                    <td class="bold-title">Alamat</td>
                    <td>:</td>
                    <td colspan="4" rowspan="3">{{faktur.faktur_pkb.service_estimate.client.client_address}}</td>
                  </tr>
                  <tr>
                    <td class="bold-title">Merek</td>
                    <td>:</td>
                    <td>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_brands.vehicle_brand_namevehicle_brand_name+" "+ faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_model}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="bold-title">Warna</td>
                    <td>:</td>
                    <td>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="bold-title">Tahun Produksi</td>
                    <td>:</td>
                    <td colspan="7">{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_production_year}}</td>
                  </tr>
                  <tr>
                    <td class="bold-title">Phone</td>
                    <td>:</td>
                    <td>{{faktur.faktur_pkb.service_estimate.client.client_phone}}</td>
                    <td class="bold-title">Email</td>
                    <td>:</td>
                    <td colspan="4">{{faktur.faktur_pkb.service_estimate.client.client_email}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table class="table-inside-td" style="width:100%; border: 1px solid black; margin-top: 2px; table-layout: fixed;" >
            <colgroup>
                    <col style="width: 14mm">
                    <col style="width: 1mm">
                    <col style="width: 25mm">
                    <col style="width: 14.5mm">
                    <col style="width: 1mm">
                    <col style="width: 17mm">
                    <col style="width: 13mm">
                    <col style="width: 1mm">
                    <col style="width: 29mm">
              </colgroup>
            <tr>
              <td class="bold-title">Tgl. Masuk</td>
              <td>:</td>
              <td>{{faktur.faktur_date_in}}</td>
              <td class="bold-title">KM masuk</td>
              <td>:</td>
              <td colspan="4">{{faktur.faktur_customer_km_in}}</td>
            </tr>
             <tr>
              <td class="bold-title">Tgl. Selesai</td>
              <td>:</td>
              <td>{{faktur.faktur_date_out}}</td>
              <td class="bold-title">KM keluar</td>
              <td>:</td>
              <td>{{faktur.faktur_customer_km_out}}</td>
              <td class="bold-title">SA Kontak</td>
              <td>:</td>
              <td>{{faktur.faktur_sa_contact}}</td>
            </tr>
          </table>


          

          <table style="width:100%; border-collapse: collapse; margin-top: 3mm;" >
          <colgroup>
                    <col style="width: 150mm">
                    <col style="width: 30mm">
            </colgroup>
            <tr>
              <td class="title-name" style="border:1px solid black; font-weight:bold;">Perincian Tagihan</td>
              <td class="title-name" style="text-align: center; border:1px solid black; font-weight:bold;">BIAYA</td>
            </tr>
          </table>
           <table class="table-inside-td" style="width:100%; border-collapse: collapse; table-layout: fixed;" >
          <colgroup>
                    <col style="width: 150mm">
                    <col style="width: 30mm ">
            </colgroup>
            <tr style="border-right:1px solid black; border-left:1px solid black;">
              <td class="bold-title" style="padding-left: 25mm; padding-top: 5mm; border-right:1px solid black;">TOTAL BIAYA JASA</td>
              <td  style="padding-top: 5mm;"><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa)}}</span></td>
            </tr>
            <tr style="border-right:1px solid black; border-left:1px solid black; border-bottom:1px solid black;">
              <td class="bold-title" style="padding-left: 25mm; padding-bottom: 5mm; border-right:1px solid black;">TOTAL BIAYA SPAREPART</td>
              <td><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_spare_part)}}</span></td>
            </tr>
          </table>

          <table class="table-inside-td" style="width:100%; border-collapse: collapse; table-layout: fixed; margin-top: 3mm;" >
          <colgroup>
                    <col style="width: 120mm; border: 1px solid black;">
                    <col style="width: 30mm; border: 1px solid black;">
                    <col style="width: 30mm; border: 1px solid black;">
            </colgroup>
            <tr>
              <td class="bold-title" style="text-decoration: underline;">Terbilang :</td>
              <td class="bold-title">Sub Total</td>
              <td><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa + faktur.faktur_total_biaya_spare_part)}}</span></td>
            </tr>
            <tr>
              <td style="padding-left: 20mm;">
                <span><sub class="bold-title" style="font-size:2.2mm; padding-left:6mm"><i># </i></sub></span>
                <span style="text-decoration:underline; text-decoration-style: dotted;">{{faktur.faktur_total_terbilang}}</span>
                <span ><sub style="font-size:2.2mm" class="bold-title"><i> RUPIAH #</i></sub></span></td>
              <td class="bold-title">PPN 10%</td>
              <td><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_ppn)}}</span></td>
            </tr>
            <tr>
              <td style=""></td>
              <td class="bold-title">Materai</td>
              <td><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_materai)}}</span></td>
            </tr>
            <tr>
              <td style=""></td>
              <td class="bold-title" style="text-align: center; border: 1px solid black;">TOTAL</td>
              <td style="text-align: center; border: 1px solid black;"><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa + faktur.faktur_total_biaya_spare_part + faktur.faktur_materai + faktur.faktur_ppn)}}</span></td>
            </tr>
          </table>

          <table class="table-inside-td" style="width:100%; border-collapse: collapse; table-layout: fixed;" >
          <colgroup>
                    <col style="width: 22mm">
                    <col style="width: 98mm">
                    <col style="width: 60mm; border: 1px solid black;">
            </colgroup>
            <tr style="border-left:1px solid black">
              <td class="bold-title" style=" text-decoration: underline; border-bottom: 1px solid black;">Saran : </td>
              <td class="bold-title" style=" border-bottom: 1px solid black;">SERVICE MOBIL KESAYANGAN ANDA DI BENGKEL MSI SERVICE BERIKUTNYA PADA KILOMETER ________ ATAU 3 BULAN BERIKUTNYA</td>
              <td class="bold-title" style="text-decoration: underline; text-align: center;">K A S I R</td>
            </tr>
            <tr style="border-left:1px solid black;">
              <td class="bold-title">Ketentuan :</td>
              <td><ul>
                  <li>Kwintas dianggap sah apabila sudah dicap/ditandatangani</li>
                  <li>Jaminan pekerjaan berlaku 1 minggu atau 300 KM</li>
                  <li>Kami tidak bertanggung jawab atas hilangnya atau terbuangnya suku cadang bekas kalau tidak diambil dalama waktu 2 haru sejak tanggak perbaikan</li>
                  </ul>
              </td>
              <td></td>
            </tr>
            <tr style="border-left:1px solid black; border-bottom:1px solid black;">
              <td></td>
              <td></td>
              <td style="text-align: center;">
                  <!-- <table>
                    <colgroup>
                      <col style="width: 10%">
                      <col style="width: 80%">
                      <col style="width: 10%">
                    </colgroup>
                    <tr style="text-align: center;">
                      <td>(</td>
                      <td >asdasdda</td>
                      <td>)</td>
                    </tr>
                  </table> -->
                  <sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:30px; padding-right:30px;">{{faktur.faktur_kasir}}</span><sub>)</sub>
              </td>
            </tr>
          </table>

            
            
          
            

                
                
                
                
           </md-card-content>
          <!-- <button class="noprint" @click="printInvoice" >Print Invoice</button>
          <button class="noprint" @click="generateReport" >Print Invoice</button> -->
        </md-card>
      </div>
    </div>
    </section>
    </vue-html2pdf>
    
    <div v-bind:style="{ display: not_found}">
      <center  v-if="faktur == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List?</a>
        </p>
      </center>
    </div>
  </div>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import angkaTerbilang from '@develoka/angka-terbilang-js';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';
  import VueHtml2pdf from 'vue-html2pdf'

  Vue.use(VueSweetalert2);

  // import InfoCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/InfoCard.vue";
  // import ClientCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ClientCard.vue";
  // import VehicleCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/VehicleCard.vue";
  // import ServiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ServiceCard.vue";
  // import PartCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/PartCard.vue";
  
  export default {
     name: "detail-faktur",

    // props: {
    //   service_estimate: Object,
    // },

    components: {
      // ValidationError,
      // FormWizard,
      // TabContent,
      // "info-card": InfoCard,
      // "client-card": ClientCard,
      // "vehicle-card": VehicleCard,
      // "service-card": ServiceCard,
      // "part-card": PartCard,
      VueHtml2pdf
      
    }, 

    mixins: [formMixin],

    data: () => ({
      not_found: 'none',
      faktur: null,
      total_pekerjaan: 0,
      total_part: 0,
      subject: 0,
      ppn: 0,
      total_estimate: 0
    }),

    created() {
      this.getFakturData();
    },

    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed().replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async getFakturData(){
        await this.$store.dispatch("workshop_faktur/get", this.$route.params.id)
        this.faktur = await this.$store.getters["workshop_faktur/faktur"]

         //check apakah data dari api ada
        if(!this.faktur){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }

        this.faktur.faktur_total_terbilang =  angkaTerbilang(this.faktur.faktur_total_biaya_jasa + this.faktur.faktur_total_biaya_spare_part + this.faktur.faktur_materai + this.faktur.faktur_ppn)
        console.log(await this.$store.getters["workshop_faktur/faktur"])
        this.$refs.html2Pdf.generatePdf()
        
        
      },

      editFaktur(id) {
      this.$router.push({ name: 'Edit Faktur', params: { faktur:id, id } })
    },

    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.deleteFaktur(id)
          }
        });
    },
    async deleteFaktur(id) {
       try {
          await this.$store.dispatch("workshop_faktur/destroy", id)
          await this.$store.dispatch("alerts/success", "Faktur data delete successfully.")
          await this.getList();
        } catch (e) {
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }
    },

      async backToList(){
          await this.$router.replace({name: 'List Faktur'})
      },
      printPage(){
         window.print()
      },

      generateReport () {
            this.$refs.html2Pdf.generatePdf()
        }

      
    },
    mounted() {
        //this.$refs.html2Pdf.generatePdf()
    }
  };
</script>
<style scoped>
.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
.checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
}
.checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
}
.checkboxes td {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.checkboxes {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.info {
  line-height: 17px;
}
.info td {
margin: 4px;
}
.bold-title{
font-weight:bold;
}
.table-inside-td td {
  vertical-align: top;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}


@media print{
   .print{
       visibility: visible;
   }
   .noprint{
     display: none;
   }

  
}

</style>